module.exports = __webpack_public_path__ + "media/customizations/lakenona/back-3e6d7108859aec86aaccc4b8c2816359.jpg";